import { Injectable } from '@angular/core';
import { UtilService } from '@app/shared/services/util.service';

@Injectable({
    providedIn: 'root'
})
export class ErrorService {
    constructor(private _utilService: UtilService) {}

    hasError(err: any, data?: string) {
        switch (err.code) {
            // Register Errors
            case 'UsernameExistsException':
                this._utilService.presentToast(
                    `El correo electrónico ${data} ya esta registrado.`,
                    'warning',
                    5000
                );
                break;

            // Login Errors
            case 'UserNotFoundException':
            case 'NotAuthorizedException':
                this._utilService.presentToast(
                    'Correo electrónico o contraseña incorrectos.',
                    'warning',
                    5000
                );
                break;

            // Forgot Password Errors
            case 'UserNotFoundException':
                this._utilService.presentToast(
                    `El correo ${data} no esta registrado.`,
                    'warning',
                    5000
                );
                break;

            case 'InvalidParameterException':
                this._utilService.presentToast(
                    `No se puede restablecer la contraseña, falta verificar su dirección de correo electrónico`,
                    'error',
                    5000
                );
                break;

            case 'LimitExceededException':
                this._utilService.presentToast(
                    `Se ha superado el límite de intentos, por favor intente después de un tiempo.`,
                    'error',
                    5000
                );
                break;

            case 'CodeMismatchException':
                this._utilService.presentToast(
                    `El código de verificación no es válido, inténtalo de nuevo.`,
                    'warning',
                    5000
                );
                break;

            // Default error
            default:
                this._utilService.presentToast(
                    `Fallo la solicitud intentalo más tarde.`,
                    'error',
                    5000
                );
                break;
        }
    }
}
